<div class="report-claim-what-to-expect" [ngClass]="{ sidebar: sidebarPresent }">
  <div class="row">
    <div class="column twelve header">
      <span class="heading-main header-text">Use Our Four-Step Process</span>
      <span class="header-subtext">To Keep Your Claim Moving</span>
    </div>
  </div>
  <div class="row steps flex wrap">
    <div class="column step twelve md-six">
      <div class="step-content">
        <div class="step-content-number">1</div>
        <div class="step-content-text">
          You've taken care of this step. Now what? First, your claims adjuster will review the
          information you submitted.
        </div>
      </div>
      <div class="step-subtext">Report Your Claim</div>
    </div>
    <div class="column step twelve md-six">
      <div class="step-content">
        <div class="step-content-number">2</div>
        <div class="step-content-text">
          Next the claims adjuster will contact you to go over options and answer any questions.
          This is your personal representative throughout the claims process&mdash;just call or
          email if questions come up along the way.
        </div>
      </div>
      <div class="step-subtext">We'll Contact You</div>
    </div>
  </div>
  <div class="row steps flex wrap">
    <div class="column step twelve md-six">
      <div class="step-content">
        <div class="step-content-number">3</div>
        <div class="step-content-text">
          We'll then review all the details of your claim, like policy coverage and repair options.
          Your adjuster will work with you to ensure a fair and accurate assessment.
        </div>
      </div>
      <div class="step-subtext">We'll Review Your Claim</div>
    </div>
    <div class="column step twelve md-six">
      <div class="step-content">
        <div class="step-content-number">4</div>
        <div class="step-content-text">
          The last step is all about completing your claim so you can get back to life. Your
          adjuster will contact you with details and complete your claim as quickly as possible.
        </div>
      </div>
      <div class="step-subtext">We'll Complete Your Claim</div>
    </div>
  </div>
  <div class="row">
    <div class="column twelve footer">
      <span class="heading-main footer-text">We're Always Here And Ready To Help.</span>
      <span class="footer-subtext"
        >Call us anytime at 1-800-MYAMFAM (1-800-692-6326) with any questions or concerns about your
        claim.</span
      >
    </div>
  </div>
  <div class="row">
    <div class="column twelve pad-top-20">
      <button ds-button class="md-float-right margin-left-30" type="button" (click)="back()">
        View Claims
      </button>
    </div>
  </div>
</div>
